import React from 'react';

const NotFoundPage: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-3xl mb-4">404 - Not Found</h1>
      <p className="text-lg text-gray-600">The page you're looking for does not exist.</p>
    </div>
  );
};

export default NotFoundPage;
